import { useEffect, useState } from 'react'

const eventLabels = {
    order_created: 'Заявка создана',
    order_updated: 'Данные заявки изменены',
    order_taken: 'Заявка взята в работу',
    order_returned: 'Заявка возвращена в общий список',
    mileage_saved: 'Пробег сохранён',
    mileage_confirmed: 'Пробег и фото одометра подтверждены',
    inspection_hints_generated: 'Подсказки ИИ получены',
    inspection_hints_failed: 'Подсказки ИИ недоступны',
    mechanic_conclusion_updated: 'Заключение механика сохранено',
    diagnostic_completed: 'Техническая диагностика завершена',
    client_summary_generated: 'Заключение для клиента сформировано',
    client_summary_updated: 'Заключение для клиента изменено',
    client_summary_confirmed: 'Заключение для клиента подтверждено',
    report_created: 'Отчёт для клиента сформирован',
    report_delivery_failed: 'Сообщение клиенту не отправлено',
    report_sent: 'Отчёт отправлен клиенту',
    order_expired: 'Заявка закрыта автоматически',
}

// иконка и цвет события в таймлайне
const eventIcons = {
    order_created: ['ti-file-plus', 'blue'],
    order_updated: ['ti-pencil', 'grey'],
    order_taken: ['ti-player-play', 'amber'],
    order_returned: ['ti-arrow-back-up', 'grey'],
    mileage_saved: ['ti-gauge', 'grey'],
    mileage_confirmed: ['ti-circle-check', 'green'],
    inspection_hints_generated: ['ti-sparkles', 'violet'],
    inspection_hints_failed: ['ti-alert-triangle', 'red'],
    mechanic_conclusion_updated: ['ti-notes', 'blue'],
    diagnostic_completed: ['ti-check', 'green'],
    client_summary_generated: ['ti-file-text', 'violet'],
    client_summary_updated: ['ti-pencil', 'grey'],
    client_summary_confirmed: ['ti-file-check', 'green'],
    report_created: ['ti-file-description', 'blue'],
    report_delivery_failed: ['ti-send-off', 'red'],
    report_sent: ['ti-send', 'green'],
    order_expired: ['ti-clock-x', 'red'],
}

const historyStyles = `
.oh{background:white;border-radius:18px;box-shadow:0 1px 2px rgba(16,24,40,.04),0 4px 14px -6px rgba(16,24,40,.08);overflow:hidden;margin-top:8px}
.oh-toggle{width:100%;display:flex;align-items:center;justify-content:space-between;gap:10px;padding:12px 14px;border:0;background:white;cursor:pointer;color:#1A1A1A;font:inherit;text-align:left}
.oh-title{display:flex;align-items:center;gap:10px;font-size:12px;font-weight:700}
.oh-icon{display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:10px;background:#F3F5F9;color:#6B7280}
.oh-icon i{font-size:16px}
.oh-count{display:inline-flex;align-items:center;justify-content:center;min-width:20px;height:20px;padding:0 6px;box-sizing:border-box;border-radius:999px;background:#F3F5F9;color:#6B7280;font-size:11px;font-weight:600}
.oh-chevron{display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:9px;background:#F3F5F9;color:#9CA3AF;transition:transform .2s}
.oh-chevron[data-open=true]{transform:rotate(180deg)}
.oh-chevron i{font-size:15px}
.oh-list{position:relative;margin:0;padding:6px 14px 12px;list-style:none;border-top:1px solid #F0F2F6}
.oh-event{position:relative;display:flex;gap:12px;padding:8px 0}
.oh-event:not(:last-child)::before{content:"";position:absolute;left:13px;top:36px;bottom:-8px;width:2px;border-radius:1px;background:#EEF1F6}
.oh-dot{--c:#0052FF;--b:#EEF3FF;position:relative;z-index:1;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;width:28px;height:28px;border-radius:9px;background:var(--b);color:var(--c)}
.oh-dot i{font-size:14px}
.oh-dot[data-tone=green]{--c:#059669;--b:#E7F8F0}
.oh-dot[data-tone=amber]{--c:#D97706;--b:#FFF7E6}
.oh-dot[data-tone=red]{--c:#DC2626;--b:#FEF2F2}
.oh-dot[data-tone=violet]{--c:#7C3AED;--b:#F3EEFF}
.oh-dot[data-tone=grey]{--c:#6B7280;--b:#F3F5F9}
.oh-text{min-width:0;padding-top:1px}
.oh-text p{margin:0}
.oh-label{font-size:11px;font-weight:600;color:#1A1A1A;line-height:1.4}
.oh-details{margin-top:3px!important;padding:5px 8px;border-radius:8px;background:#F7F8FA;font-size:10px;color:#4B5563;line-height:1.45;overflow-wrap:anywhere}
.oh-meta{display:flex;flex-wrap:wrap;gap:2px 8px;margin-top:3px!important;font-size:9px;color:#9CA3AF}
.oh-meta span{display:inline-flex;align-items:center;gap:3px}
.oh-empty{margin:0;padding:12px 14px;border-top:1px solid #F0F2F6;font-size:11px;color:#9CA3AF}
.oh-empty[data-error=true]{color:#DC2626}
.oh button:focus-visible{outline:2px solid #0052FF;outline-offset:-2px}
`

const fieldLabels = {
    car_brand: 'Марка',
    car_model: 'Модель',
    car_year: 'Год',
    engine_type: 'Тип двигателя',
    plate: 'Госномер',
    vin: 'VIN',
    order_number: 'Заказ-наряд',
    client_name: 'Клиент',
    client_phone: 'Телефон',
}

const valueText = (value) => value === null || value === undefined || value === '' ? 'не указано' : String(value)

const eventDetails = (event) => {
    const payload = event.payload || {}
    if (event.event_type === 'order_updated' && payload.changes) {
        return Object.entries(payload.changes).map(([field, change]) => (
            `${fieldLabels[field] || field}: ${valueText(change.old)} → ${valueText(change.new)}`
        )).join('; ')
    }
    if (payload.mileage) return `Пробег: ${Number(payload.mileage).toLocaleString('ru-RU')} км`
    if (payload.method) return payload.method === 'manual' ? 'Отправлено сотрудником вручную' : 'Автоматическая отправка через SailPlay'
    return null
}

export default function OrderHistory({ orderId, token, refreshKey = null }) {
    const [events, setEvents] = useState([])
    const [expanded, setExpanded] = useState(false)
    const [error, setError] = useState(false)

    useEffect(() => {
        fetch(`/api/orders/${orderId}/events`, { headers: { Authorization: `Bearer ${token}` } })
            .then(async (response) => {
                if (!response.ok) throw new Error('history')
                return response.json()
            })
            .then(setEvents)
            .catch(() => setError(true))
    }, [orderId, token, refreshKey])

    const time = value => new Date(value).toLocaleString('ru-RU', { timeZone: 'Europe/Moscow', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })

    return (
        <div className="oh">
            <style>{historyStyles}</style>
            <button type="button" className="oh-toggle" onClick={() => setExpanded(value => !value)} aria-expanded={expanded}>
                <span className="oh-title">
                    <span className="oh-icon"><i className="ti ti-history" aria-hidden="true" /></span>
                    История заявки
                    {!error && <span className="oh-count">{events.length}</span>}
                </span>
                <span className="oh-chevron" data-open={expanded}><i className="ti ti-chevron-down" aria-hidden="true" /></span>
            </button>
            {expanded && (error ? (
                <p className="oh-empty" data-error="true">Не удалось загрузить историю</p>
            ) : events.length === 0 ? (
                <p className="oh-empty">Событий пока нет</p>
            ) : (
                <ol className="oh-list">
                    {events.map(event => {
                        const details = eventDetails(event)
                        const [icon, tone] = eventIcons[event.event_type] || ['ti-point', 'grey']
                        return (
                            <li key={event.id} className="oh-event">
                                <span className="oh-dot" data-tone={tone}><i className={`ti ${icon}`} aria-hidden="true" /></span>
                                <div className="oh-text">
                                    <p className="oh-label">{eventLabels[event.event_type] || event.event_type}</p>
                                    {details && <p className="oh-details">{details}</p>}
                                    <p className="oh-meta">
                                        <span><i className="ti ti-clock" aria-hidden="true" />{time(event.created_at)}</span>
                                        <span><i className={`ti ${event.actor_name ? 'ti-user' : 'ti-robot'}`} aria-hidden="true" />{event.actor_name || 'система'}</span>
                                    </p>
                                </div>
                            </li>
                        )
                    })}
                </ol>
            ))}
        </div>
    )
}
